// extracted by mini-css-extract-plugin
module.exports = {"container":"CryptoPaymentList_container_2S-sq","date":"CryptoPaymentList_date_3aaO7"};